




























































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import auth from "../services/auth";
import configuration from "@/models/Configuration";
import permStore from "@/services/permissions";
import globalStore from "@/models/GlobalStore";
import { getLanguage, setLanguage, Language, LANGUAGE_NAMES, SUPPORTED_LANGUAGES } from "@/plugins/i18n";

export default Vue.extend({
  data: () => ({
    permStore,
    configuration,
    menuOpened: false,
    ledgerMenu: false,
    globalStore,
    languages: SUPPORTED_LANGUAGES.map((code) => ({ code, name: LANGUAGE_NAMES[code] })),
  }),

  beforeMount() {
    if (
      localStorage.getItem("primaryColor") &&
      localStorage.getItem("primaryColorHover") &&
      localStorage.getItem("textColor")
    ) {
      this.$vuetify.theme.themes.light.primary = localStorage.getItem("primaryColor") ?? "#f67a1c";

      document.documentElement.style.setProperty("--primaryColor", localStorage.getItem("primaryColor"));

      document.documentElement.style.setProperty("--primaryColorHover", localStorage.getItem("primaryColorHover"));

      document.documentElement.style.setProperty("--textColor", localStorage.getItem("textColor"));
    } else {
      this.setTheme("#f67a1c", "#be5606", "#FFFFFF");
    }
  },

  methods: {
    changeLanguage(language: Language) {
      if (language === getLanguage()) return;
      setLanguage(language);
      // A szótár és a Kendo feliratok teljes újratöltéssel váltanak biztosan
      window.location.reload();
    },

    changePassword() {
      this.$router.push("/change-password");
    },

    setTwoFactorAuthentication(){
      this.$router.push("/two-factor-authentication");
    },

    navigate(to: string) {
      if (this.$route.path != to) {
        this.$router.push(to);
      }
    },

    navigateLedger(to: string) {
      this.ledgerMenu = false;
      this.navigate(to);
    },

    logout() {
      auth.logout();
    },

    setTheme(primaryColor: string, primaryColorHover: string, textColor: string) {
      this.$vuetify.theme.themes.light.primary = primaryColor;
      document.documentElement.style.setProperty("--primaryColor", primaryColor);
      document.documentElement.style.setProperty("--primaryColorHover", primaryColorHover);
      document.documentElement.style.setProperty("--textColor", textColor);

      localStorage.setItem("primaryColor", primaryColor);
      localStorage.setItem("primaryColorHover", primaryColorHover);
      localStorage.setItem("textColor", textColor);

      // console.log(localStorage.getItem("primaryColor"));
      // console.log(localStorage.getItem("primaryColorHover"));
      // console.log(localStorage.getItem("textColor"));
    },

    checkPermission(name: string): boolean {
      const menuPerm = auth.menuPermissions.find(x => x.name == name);
      return menuPerm?.isGranted ?? false;
    }
  },

  computed: {
    currentLanguageName(): string {
      return LANGUAGE_NAMES[getLanguage()];
    },

    userName() {
      return auth.userName;
    },

    database() {
      return window.localStorage.getItem("trufinance.connectionID");
    },

    canEditDeadlines() {
      return this.permStore.hasPermitting() || this.permStore.hasPermitting();
    },
  },
});
